import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import { useHistory, useParams } from 'react-router';
import { generatePath } from 'react-router';

const Icon = (props) => {
  const { user } = props;
  const { id, siteId } = useParams();
  const [campaign, setCampaign] = useState({ campaign_id: null, campaign_name: null });
  const [imageData, setImageData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();
  const history = useHistory();

  const [values, setValues] = useState({
    site_id: siteId,
    campaign_id: id,
    image_id: '',
    image_name: '',
    image_url: '',
    remarks: '',
    upd_date: null,
    uploadfile: null,
    uploadfiletype: null,
    deletefile: null
  });

  const refreshData = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');

    const campaignlist = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/campaign/search`, { site_id: siteId, campaign_id: id }, { headers: { Authorization: `Bearer ${jwt}` } })).data;
    if (campaignlist.length > 0) setCampaign(campaignlist[0]);
    const imageData = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/campaignimage/search/` , { site_id: siteId, campaign_id: id }, { headers: { Authorization: `Bearer ${jwt}` }})).data;
    setImageData(imageData);
    
  }, [siteId, id]);

  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    var temp = data;
    temp.deletefile = null;
    temp.uploadfiletype = null;
    if (data.image_url != null) temp.uploadfile = `/${siteId}/${constClass.CAMPAIGN_IMAGE_DIR}${id}/${data.image_url}`;
    else temp.uploadfile = null;
    setValues(temp);
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      site_id: siteId,
      campaign_id: id,
      image_id: '',
      image_name: '',
      image_url: '',
      remarks: '',
      upd_date: null,
      uploadfile: null,
      uploadfiletype: null,
      deletefile: null
    });
  }
  
  const handleBackClick = () =>{
    history.push(`${generatePath(`${props.match.path}campaignpage/${id}`, { siteId })}`);
  }
  /* DB更新 */
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    
    if ((data.uploadfiletype === null && data.image_url === '')
    || (data.uploadfiletype === null && data.image_url === data.deletefile)) {
      window.alert('アイコン画像を登録してください。');
      return;
    }
    var params = data;
    if (data.uploadfiletype === null) data.uploadfile = null;
    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;

    if (!window.confirm(`[${data.image_id}:${data.image_name}]を登録します。よろしいですか？`)) {
      return;
    }

    let res;
    try {
      setLockData(true);
      if (params.image_id === null || params.image_id === "") {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/campaignimage/`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      } else {
        res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/campaignimage/${params.image_id}`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      }
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }
  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`画像[${data.image_id}:${data.remarks}]を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: data.site_id,
      campaign_id: data.campaign_id,
      image_id: data.image_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/campaignimage/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData}
        className={`btn btn-primary mx-1 w-75`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.image_id === ''}
        className={`btn btn-primary mx-1 w-75`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-75`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  const backButton = () => {
    return(
      <button type="button"
        className={`btn btn-primary mx-1 w-75`}
        onClick={() => handleBackClick()}>
        戻る
      </button>
    )
  }

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  const handleChangeFile = (e) => {
    const value = e.target.files[0];
    var reader = new FileReader();
    reader.onloadend = () => {
      setValues({
        ...values,
        uploadfile: reader.result,
        uploadfiletype: value.type,
        deletefile: values.image_url
      });
    }
    reader.readAsDataURL(value);
  }

  const handleDeleteFile = () => {
    setValues({ ...values, uploadfile: null, uploadfiletype: null, deletefile: values.image_url });
  }

  useEffect(() => {
    refreshData();
  }, [refreshData]); //

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>画像ID</span>
          </div>
          <div className="col-2 text-center align-self-center">
            <input type="text" className="form-control" name="image_id" value={values.image_id || ""} placeholder="新規" onChange={handleChange} readOnly />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>名前</span>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" name="image_name" value={values.image_name || ""} placeholder="名前を入力してください" onChange={handleChange} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>備考</span>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" name="remarks" value={values.remarks || ""} onChange={handleChange} placeholder="備考を入力してください" />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="remarks">画像</label>
          </div>
          <div className="col-5 align-self-center">
            {!(values.uploadfile) && <input type="file" className="form-control-file" name="image" id="image" value="" onChange={handleChangeFile} onClick={e => (e.target.value = null)} />}
            {values.uploadfile && <object className="image-lg" id="uploadfileview" data={values.uploadfile} type={values.uploadfiletype}><img src={values.uploadfile} alt='uploadfile' /></object>}
            {values.uploadfile && <input type="button" className="form-controll" name="deletefile" id="deletefile" onClick={handleDeleteFile} value="ファイル削除" />}
          </div>
        </div>
        <div className="row mb-2 py-4">
          <div className="col-3 text-center">
            {renderRegistButton(values)}
          </div>
          <div className="col-3 text-center">
            {renderDeleteButton(values)}
          </div>
          <div className="col-3 text-center">
            {renderResetButton(values)}
          </div>
          <div className="col-3 text-center">
            {backButton()}
          </div>
        </div>
      </div>
    );
  }

  const renderList = () => {
    return (
      <div className="row mb-3 p-0">
        <div className="col-12 p-0">
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  キャンペーン
                </td>
                <td className="text-center align-middle">
                  画像ID
                </td>
                <td className="text-center align-middle">
                  名前
                </td>
                <td className="text-center align-middle">
                  画像URL
                </td>
                <td className="text-center align-middle">
                  備考
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {imageData.map((data, idx) => (
                <tr key={data.image_id}>
                  {/* キャンペーン */}
                  <td className="text-center align-middle">
                    {campaign.campaign_name}
                  </td>
                  {/* 画像ID */}
                  <td className="text-center align-middle">
                    {data.image_id}
                  </td>
                  {/* 名前 */}
                    <td className="text-center align-middle">
                    {data.image_name}
                  </td>
                  {/* 画像URL */}
                  <td className="text-center align-middle ">
                    <div className="px-0 text-center">
                      {`/${data.site_id}/${constClass.CAMPAIGN_IMAGE_DIR}${data.campaign_id}/${data.image_url}`}
                      {/* <img className="image-lg" src={`/${siteId}/${constClass.CAMPAIGN_IMAGE_DIR}${data.campaign_id}/${data.image_url}`} onError={e => e.target.style.display = 'none'} alt="" /> */}
                    </div>
                  </td>
                  {/* 備考 */}
                  <td className="text-center align-middle">
                    {data.remarks}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      {imageData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {imageData !== null && (renderList())}
      {renderInput()}
    </div>
  )
}

export default Icon;